/**
 * Updates Open Graph and Twitter Card meta tags for social sharing.
 * Call this from each page's useEffect with page-specific title and description.
 */
const DEFAULT_OG_IMAGE = 'https://pinhighbay.com/home-hero.jpg';
const DEFAULT_OG_IMAGE_WIDTH = '1024';
const DEFAULT_OG_IMAGE_HEIGHT = '683';

export function updateSocialMeta({
  title,
  description,
  path,
  image = DEFAULT_OG_IMAGE,
  imageWidth = DEFAULT_OG_IMAGE_WIDTH,
  imageHeight = DEFAULT_OG_IMAGE_HEIGHT,
}) {
  const url = `https://pinhighbay.com${path}`;

  const ogTags = [
    ['og:url', url],
    ['og:title', title],
    ['og:description', description],
    ['og:image', image],
    ['og:image:width', imageWidth],
    ['og:image:height', imageHeight],
  ];

  const twitterTags = [
    ['twitter:url', url],
    ['twitter:title', title],
    ['twitter:description', description],
    ['twitter:image', image],
  ];

  ogTags.forEach(([key, value]) => {
    let el = document.querySelector(`meta[property="${key}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('property', key);
      document.head.appendChild(el);
    }
    el.setAttribute('content', value);
  });

  twitterTags.forEach(([key, value]) => {
    let el = document.querySelector(`meta[name="${key}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', key);
      document.head.appendChild(el);
    }
    el.setAttribute('content', value);
  });
}
